import { useGetHtmlTag } from 'root/hooks/useGetHtmlTag';

export const useMenuLogic = () => {
  const menuTitleHtmlTag = useGetHtmlTag('menuTitleTheme');
  const menuDescriptionHtmlTag = useGetHtmlTag('menuDescriptionTheme');

  return { menuTitleHtmlTag, menuDescriptionHtmlTag };
};
